module.exports = __webpack_public_path__ + "assets/b34035e76011ef173f7ebb6c71dadf4c.png";